import { Container, Paper } from '@mui/material';
import React from 'react';
import Header from '../components/Header';
import Form from '../components/Form';

const Home = () => {
  return (
    <Container maxWidth="sm" sx={{ pt: 4 }}>
      <Paper sx={{ p: 4 }} elevation={6}>
        <Header />
        <Form />
      </Paper>
    </Container>
  );
};

export default Home;
